import axios from "axios";
import Qs from "qs";
// import {legacy_createStore as createStore} from 'redux';
import {createStore} from 'redux';
import {url, stringobj} from "./env";
import MobileDetect from "mobile-detect";
// import { Promise } from "es6-promise";
import CryptoJS from 'crypto-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { Base64 } from 'js-base64';
import React, {useEffect, useState} from "react";
import osName from "./OsName";
import useActiveState from "./lib/useActiveState";


// Promise.polyfill();

// axios.defaults.timeout = 600000;
export const imgPlaceholder = {
  // default: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAMAAACZHrEMAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAUVBMVEX5+vz29/jy8/P09PT4+fv19fbz8/Py8vL19vb39/n3+Pr29vf19vf3+Pn09PXz9PTz8/T5+vv4+fr4+Pr09fby8vP09fX5+fv29vj39/j///8vu+Y4AAAAAWJLR0QadWfkMgAAAAd0SU1FB+UIEgYEKvtnhCQAAAVgSURBVHja7ZnpkqM6DEYxeAkYzBYg/f4veiVvQIBA0z0zVbf0/Zh0iMDHkmzJTJKQSCQSiUQikUgkEolEIpFIJBKJRCLdFEszfmokpPgrMEqpx5lNDkbFZ5NCizK/R1CV0RswTpw1K/edVIGRKVfS1QqlVih5BwcfzjYw3CjV7N+Qqq3M+nlO+ioBY8HVTM00M0wDf6atN2kX5knSfabBb5lS6J7qHCRJtLR+ZPO4PgsijFnOrLSjN8F9CWfrKD3wcZ3/UShjJNzfi+zItUu1JkznGe4PMwsw6GoZfFEH88NFhOYhQ5QqWZPkQ6b1THgsHFuKEadbzsN1Sxiz8LFx5sMqCfhK5WzOwbiR8CAhrsQJzNWIn4CQOvQuQPjPFsO+mLU1h1jIyV0ycpMzcn46A88UaiwgGU4XFBBLHqh8HkDCqQVMsZgUmKf2jz5cHHfyN5rjQwc5Makq3px7BmZVh/CGNBBrGIj2wGdzl0+TdGF1LINMB690SE1cawjDs55JxsWFMM0hkDGFIQavBQyM10wzzBhhhNuAB4aorZO366WsHEzJSs1kxe7CLH4TLmp1cgAD/w6Qae3okz/pRB6ib2Eklzz9kkV3A6YTT5B44MdoF85TYK6OcJFtYbjj5ZDXnPsQ1z6TUgdTw57XqJFdWU1vMLX6oHwDU9is91u+vV4YtoLZS+urMPITzGsD01uYQqLzmhAoCY2HCWFyym7BVI2chcm5+D7u5Izfrbn3C6pSKffhs5teBt4Gu+p3EnipdxjjN+5qsdX3fGp8fQOYjBWVSPLqL8BwrAu1ZlWlX16seslQ3gBmMLCgEmFuhAmHESOfYSphxrI4hHEtx47itp5ywRSXurkFM8Yr86NHfgQDWbbH4m/A3Ol5pliZ3PNMHVZpspnoHgzkyKt8Ewvstgy3uMzFoq/4AUxtp24Ocobvt8Yt51gZJttpGMjxmzmzhsHDSiFVaP7eYHZLdpDbsXWXVQVvuIbs+SGMC0+nQue1huHpJxisC0x9pUpo7GpTc8ZyBuNGxsbYHHtm2MhetXUhm+HOD4QnMD5Hs2D1njPT1O4/d/JNBw/VTvanLD+FweGYeNfqAGkPH1Kc++UXYMRuvqRLnK644JXfgDHqQOza+L8JY6tByfKVGOb1+UK+CJNehsF02DmbvdT1s/VHmCYee85huN2AuEkXXZBMtZ1R832YIcKkbugpnkZOYR6+7SzeK7attvKbJIlNQF8EvWc7Gc+5OzBxEG4Ln/PMNMqVXta99XdR3HGx9FQKV2A1V7QdmDwkQ+a2VBUPxSvpezljITKNvY8LgIiLaQ/GQhhdNmrRWwm2ljaLpuNb4vFAUAeCcMrfg7F9ppqbisO6/XWDxb0is/ObAkHYr4boazF3w9E8iT/t6NYrPKteC6FD5DsR985OhLjzcvF+sQDz1/y105vaJFh7Zdz/g8BtRXknI/+AaljF4trbyj8vBsn9L2HKnhmdcGFfKvA8sTAdJnQVE5yZJ7bpvcgEfjLWmQdPSqN/OaCTwu1HpG4NZz5MGr1jQjPbuLYlD+2LfVNganWrLH0Sx83+iU/N1JwzKxiBm5DJ4cceCxoW0RzJwDd3I5q97VaP4JkRy5TGMtPuw4RXr7ZXGOFchUD2W++3zfdqrs5g3l9ViQVMga+HPsC4nc2WkRF+cTA1wnzdgznMGQuz8YzGWsZ9ykDWdtwytGixgfm9nNkLE0y1sa2DUbbXEHiKLuEc0mDZXMDc6cY/CP/XhOO73ByS+GWmhGWwDecNnFUNJm/iXoYYuKgHl2pPbEGyEu+7eDQhkUgkEolEIpFIJBKJRCKRSCQSiURa6D97/lwBuNbmpgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wOC0xN1QyMjowNDo0MiswODowMDbyyiEAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDgtMTdUMjI6MDQ6NDIrMDg6MDBHr3KdAAAAIHRFWHRzb2Z0d2FyZQBodHRwczovL2ltYWdlbWFnaWNrLm9yZ7zPHZ0AAAAYdEVYdFRodW1iOjpEb2N1bWVudDo6UGFnZXMAMaf/uy8AAAAYdEVYdFRodW1iOjpJbWFnZTo6SGVpZ2h0ADE0MBv9bjQAAAAXdEVYdFRodW1iOjpJbWFnZTo6V2lkdGgAMTQwiAw+aQAAABl0RVh0VGh1bWI6Ok1pbWV0eXBlAGltYWdlL3BuZz+yVk4AAAAXdEVYdFRodW1iOjpNVGltZQAxNjI5MjA5MDgyw6U4aAAAABJ0RVh0VGh1bWI6OlNpemUAMzY5NkJCaieu3gAAAEZ0RVh0VGh1bWI6OlVSSQBmaWxlOi8vL2FwcC90bXAvaW1hZ2VsYy9pbWd2aWV3Ml85XzE2MjY2NzkwOTIzNTU1NjYyXzEwX1swXcurOUYAAAAASUVORK5CYII=',
  // default: '/resources/index/projectdefault.png',
  default: '/resources/placeholder/game-icon.png',
};

const reducer = (state = {}, action) => {
  if (action.data) {
    return action.data;
  }
  return state;
}

export const redux = createStore(reducer);

// console.log(stringobj);

const createAxios = axios.create({baseURL: url/*, timeout: 15000*/});
// const createAxios = axios.create({baseURL: url, timeout: 600000});

// createAxios.defaults.timeout = 600000;

const mobileDetect = new MobileDetect(navigator.userAgent);
const strnum = 8;
// const secretKey = process.env.REACT_APP_SECRET_KEYS + "02201015";
const secretKey = "_)94*KM&(8nv9!%202201015";
// console.log("123");
//浏览器指纹
const fpPromise = FingerprintJS.load();
(async () => {
  // Get the visitor identifier when you need it.
  const fp = await fpPromise;
  const result = await fp.get();

  // This is the visitor identifier:
  const visitorId = result.visitorId;

  localStorage.setItem('visitorId', visitorId);
})();

const getKeys = (a, b) => {
  // const keyStr = '2%!9vn8(&MK*49)_';
  // let keyStr="_)94*KM&(8nv9!%2".split("").reverse().join("");
  // let keyStr = "_)94*KM&(8nv9!%2";

  var encoder = new TextEncoder();
  var utf8Bytes = encoder.encode(a);

  // 去除后8个字节
  var trimmedBytes = utf8Bytes.slice(0, utf8Bytes.length - b);

  // 将字节序列解码为字符串
  var decoder = new TextDecoder();
  var trimmedString = decoder.decode(trimmedBytes);
  
  return trimmedString;
}

// console.log(getKeys());

// console.log(secretKey);
// const secretKey = stringobj;

// console.log(secretKey);

createAxios.interceptors.request.use(
    config => {
      config.paramsSerializer = params => Qs.stringify(params, {arrayFormat: 'indices'})
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['device-type'] = '20';
      config.headers['device-name'] = mobileDetect.phone();
      config.headers['sdk-version'] = '156';
      config.headers['edition-switch'] = '12';
      config.headers['origintype'] = 'react';
      config.headers['react-method'] = window.location.protocol;
      config.headers['react-host'] = window.location.host;
      // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      if(mobileDetect.os() == 'iOS' || general.mb == 1) {
        config.headers['device-type'] = '10';
        // mobileDetect.is('iPad');
        if(mobileDetect.is('iPad')) {
          config.headers['device-version'] = mobileDetect.os() + mobileDetect.versionStr('iPad')?.replace(/_/g, ".");
        } else if(mobileDetect.is('iPhone')) {
          config.headers['device-version'] = mobileDetect.os() + mobileDetect.versionStr('iPhone')?.replace(/_/g, ".");
        }
        if (general.mb == 1){
          config.headers['device-version'] = 'iOS' + mobileDetect.versionStr('iPhone')?.replace(/_/g, ".");
        }
      } else if (mobileDetect.os() == 'AndroidOS') {
        config.headers['device-type'] = '20';
        config.headers['device-version'] = mobileDetect.os() + mobileDetect.version('Android');
      }
      if (osName() == 'Harmony') {
        config.headers['device-type'] = '30';
      }
      //嘿咕默认渠道：43iq
      //52玩默认渠道：ipw4
      // config.headers['channel'] = localStorage.getItem('agent') || 'ipw4';
      config.headers['channel'] = general.agent;
      if (localStorage.getItem('udid')) {
        config.headers['udid'] = localStorage.getItem('udid');
      }
      if (localStorage.getItem('key')) {
        config.headers['fid'] = localStorage.getItem('key');
      }
      let token = localStorage.getItem('token');
      if (token) {
        config.headers['token'] = token;
      }
      if (localStorage.getItem('idfv')) {
        config.headers['device-id'] = localStorage.getItem('idfv');
      }
      if (localStorage.getItem('pck_name')) {
        config.headers['pck-name'] = localStorage.getItem('pck_name');
      }
      let is_b = localStorage.getItem('is_b');
      if (is_b) {
        config.headers['isb'] = 1;
      }
      
      let visitorId = localStorage.getItem('visitorId');
      if(visitorId) {
        config.headers['fpid'] = visitorId;
      } else {
        (async () => {
          const fp = await fpPromise;
          const result = await fp.get();

          const visitorId = result.visitorId;
        
          config.headers['fpid'] = visitorId;
          localStorage.setItem('visitorId', visitorId);
        })();
      }

      config.headers['unid'] = localStorage.getItem("appkey");

      config.headers['tk'] = general.tk?general.tk:'';
      config.headers['tk-url'] = general.tkUrl?general.tkUrl:'';
      config.headers['bd-vid'] = general.bdvid?general.bdvid:'';
      config.headers['exten-d'] = general.extend?general.extend:'';
      config.headers['clue-token'] = general.clueToken?general.clueToken:'';
      config.headers['clickid'] = general.clickId?general.clickId:'';
      config.headers['username'] = localStorage.getItem('username');
      let user_id = localStorage.getItem('user_id');
      let username = localStorage.getItem('username');
      if (user_id || username) {
        if (config.data instanceof FormData) {
          if (!config.data.get('member_id')) {
            config.data.append('member_id', user_id);
          }
          if (!config.data.get('username')) {
            config.data.append('username', username);
          }
        } else {
          config.data = {username, member_id: user_id, ...config.data};
        }
      }

      //post数据加密处理
      if (config.method == 'post') {
        // if(config.data) {
        //   //判断需要加密的接口
        //   if(config.url.indexOf('ysyCheckAvailable') == -1 && general.interArr.includes(config.url) == false) {
        //     config.data = {data: encrypt(config.data)};
        //   }
        // }
        if(window.location.hostname !== 'localhost' && window.location.hostname !== '192.168.110.158' && !general.debug) {
          //判断需要加密的接口
          if(config.url.indexOf('ysyCheckAvailable') == -1 && general.interArr.includes(config.url) == false) {
            config.data = {data: encrypt(config.data, getKeys(secretKey, strnum).split("").reverse().join(""))};
            // config.data = {data: encrypt(config.data)};
          }
        }
        // console.log(JSON.parse(decrypt('dfeRzNXgpzXu6KA4hUKVrC+tfZq5H3HymzyRj/FaoDhD/OlDF91mOYuyvP3bpbOsSvNfysDKzVnZk0Mjbg4mpuj+kxuLuVj9lYu780IYcmb/lx5yaD7KdfOUWR2uC5QsviCL3v9XGY/PILXGxym8RRoBBMB8TNB/0AImvPxLqCTdTBB0H1XsKW4nHhjmNo8ztmVrKilEfshU2WCNC1tLTg==')));
      }
      
      return config;
    },
    err => {
      return Promise.reject(err);
    }
)

//数据响应拦截器
createAxios.interceptors.response.use(
  req=>{
    //解密解析处理返回值 仅post
    if(req.config.method == 'post') {
      if(window.location.hostname !== 'localhost' && window.location.hostname !== '192.168.110.158' && !general.debug) {
        //处理判断需要解密的接口
        if(req.config.url.indexOf('ysyCheckAvailable') == -1 && general.interArr.includes(req.config.url) == false) {
          req['data'] = JSON.parse(decrypt(req.data.data, getKeys(secretKey, strnum).split("").reverse().join("")));
          // req['data'] = JSON.parse(decrypt(req.data.data));
        }
      }
      return req;
    }

    return req;
  },
  err=>{
    
  }
);

const createAxiosNew = axios.create({baseURL: url/*, timeout: 15000*/});

createAxiosNew.interceptors.request.use(
    config => {
      config.paramsSerializer = params => Qs.stringify(params, {arrayFormat: 'indices'})
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      let user_id = localStorage.getItem('user_id');
      let username = localStorage.getItem('username');
      if (user_id || username) {
        if (config.data instanceof FormData) {
          if (!config.data.get('member_id')) {
            config.data.append('member_id', user_id);
          }
          if (!config.data.get('username')) {
            config.data.append('username', username);
          }
        } else {
          config.data = {username, member_id: user_id, ...config.data};
        }
      }
      
      return config;
    },
    err => {
      return Promise.reject(err);
    }
)

// 分割密钥
const splitKey = (key) => {
  const splitIndex = Math.floor(key.length / 2);
  const part1 = key.substring(0, splitIndex);
  const part2 = key.substring(splitIndex);
  return [part1, part2];
}

const txs = (as1, as2) => {
  return as1 + as2;
}

//接口数据加密
const encrypt = (word, key) => {
  const [part1, part2] = splitKey(key);

  let tx = txs(part1, part2);

  // var keyStr = '2%!9vn8(&MK*49)_';
  // const keyStr="_)94*KM&(8nv9!%2".split("").reverse().join("");
  var srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(word));
  var key = CryptoJS.enc.Utf8.parse(tx);
  var datas = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB, 
    padding: CryptoJS.pad.Pkcs7
  });

  return datas.toString();
}

//接口数据解密
const decrypt = (word, key) => {
  // const keyStr = '2%!9vn8(&MK*49)_';
  // const keyStr="_)94*KM&(8nv9!%2".split("").reverse().join("");
  // readTextFile(file);

  const [part1, part2] = splitKey(key);
  let tx = txs(part1, part2);
  var key = CryptoJS.enc.Utf8.parse(tx);
  var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  });

  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

// console.log(window.location.hash.substring(1));
const general = {
  history: null,
  location: null,
  goBack(callback) {
    if (callback) {
      if (general.callback) {
        general.callbacking = true;
        var si = setInterval(() => {
          let url = window.location.hash.substring(1);
          if (url === general.callback || url === '/') {
            clearInterval(si);
            general.callbacking = null;
            general.callback = null;
            redux.dispatch({
              type: 'type',
              data: {
                url: url,
              }
            });
          } else {
            window.history.back();
          }
        }, 250);
      }
    }
  },
  axios: createAxios,
  axiosnew: createAxiosNew,
  isLogin() {
    return !!localStorage.getItem('token');
  },
// agent: localStorage.getItem('agent') || '43iq',
// agent: localStorage.getItem('agent') || 'xfq6',
// agent: localStorage.getItem('agent') || 'dxi8',
agent: localStorage.getItem('agent') || 'mc6s',
  setAgent() {
    localStorage.setItem('agent', this.agent);
  },
  udid: localStorage.getItem('udid'),
  setUdid() {
    localStorage.setItem('udid', this.udid);
  },
  key: localStorage.getItem('key'),
  setKey() {
    localStorage.setItem('key', this.key);
  },
  app: JSON.parse(localStorage.getItem('app')) || {
    appname: '嘿咕游戏',
    appicon: '/resources/icon.png',
    applogo: '/resources/account/logo.png',
  },
  setApp() {
    localStorage.setItem('app', JSON.stringify(this.app));
  },
  mb: localStorage.getItem('mb'),
  setMb() {
    localStorage.setItem('mb', this.mb);
  },
  visitorId: localStorage.getItem('visitorId'),
  setVisitorId() {
    localStorage.setItem('visitorId', this.visitorId);
  },
  likeTags: localStorage.getItem('likeTags') || 0,
  setLikeTags() {
    localStorage.setItem('likeTags', this.likeTags);
  },
  debug: localStorage.getItem('debug'),
  setDebug() {
    localStorage.setItem('debug', this.debug);
  },
  config: {},
  user: {},
  rebateContent: '',
  activeInfo: {},
  copyright: '',
  searchHistory: {},
  questions: {},
  tk: '',
  tkUrl: '',
  bdvid: '',
  extend: '',
  navLists: [],
  copyPopState: '',
  clueToken: '',
  clickId: '', //抖音注册 还是啥？
  randomColorInfo: ['#a7d676', '#ffa95c', '#ffc000', '#79b8ff', '#54C5CD'],
  ceshiNumbei: ['ceshi1', 'ceshi2', 'ceshi3', 'ceshi4', 'ceshi5', 'ceshi6', 'ceshi7', 'ceshi8', 'ceshi9', 'maiyouceshi'],
  // placeholderAgent: ['ue70', 'w8v6', 'rr2f']，
  interArr: ['/base/comment/add', '/base/feedback', '/user/trade/submitTradeDetail', '/user/trade/uploadImagePublicOss', '/user/user/uploadAvatar', '/upload_image','/base/community/image','/base/community/video','/cloudMachineFeedBack'],//不需要加密接口数组
  whether: localStorage.getItem('whether') || 'true',
  setWhether() {
    localStorage.setItem('whether', this.whether);
  }
}

export default general;